import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants/routes';
import { cn } from '@/lib/utils';

export function PromotionCtaButton({ children, className, underline = false, showArrow = true }) {
  const location = useLocation();
  const { region } = useParams();
  return (
    <Button
      asChild
      className={cn(
        'group h-14 cursor-pointer rounded-2xl bg-brand-600 px-7 text-lg font-bold text-white shadow-md shadow-brand-900/15 transition-all hover:bg-brand-700 hover:shadow-lg hover:shadow-brand-900/20 sm:h-16 sm:px-9 sm:text-xl',
        className
      )}
    >
      <Link
        to={ROUTES.promotionEnrollment}
        state={{ from: location.pathname, region }}
      >
        <span className={underline ? 'underline underline-offset-4' : ''}>
          {children}
        </span>
        {showArrow && (
          <ArrowRight
            className="ml-2 size-5 transition-transform group-hover:translate-x-0.5 sm:size-6"
            aria-hidden="true"
          />
        )}
      </Link>
    </Button>
  );
}